import React from "react";

function AuthFooter() {
  return (
    <div className="mt-auto" style={{ zIndex: 1 }}>
      <div className="mt-4 mb-3 mt-md-5 text-center right-footer">
        <p className="mb-0">
          © <script>document.write(new Date().getFullYear())</script> Orangiuz.
          Desenvolvido por Orangiuz Tecnologia
        </p>
      </div>
    </div>
  );
}

export default AuthFooter;
